var HPEServices = require('../../../base/hpe.services');
var HPEConstants = require('../../../base/hpe.constants');
var HPERouter = require('../../../base/hpe.router');

/**
 * Product catalog specific router based on core HPE router
 */
module.exports = HPERouter.extend({

    props: {
        catalogPath: 'string'
    },

    derived: {
        serviceURL: {
            deps: ['dynamicPath'],
            fn: function() {
                if (this.useQueryParams) {
                    return window.location.protocol + '//' + window.location.host + this.path + '.q.json?' + this.dynamicPath;
                } else {
                    var tmpServiceURL = window.location.protocol + '//' + window.location.host + this.dynamicPath + '.q.json'; // eslint-disable-line no-inner-declarations
                    if (window.location.search) {
                        tmpServiceURL = tmpServiceURL + window.location.search;
                    }
                    return tmpServiceURL;
                }
            }
        },
        catalogURL: {
            deps: ['catalogPath'],
            fn: function() {
                var url = window.location.protocol + '//' + window.location.host + this.catalogPath + '.html'; // eslint-disable-line no-inner-declarations
                if (window.location.search) {
                    url = url + window.location.search;
                }
                return url;
            }
        }
    },

    /**
     * override default updatePath method with one that traps for more complex/custom nested values
     */
    updatePath: function() {

        var newPath = this.path;
        var newCatalogPath = this.path;
        var that = this;
        var key, serializedObject;

        for (key in this.currentState) {

            //children may be simple values or more complex objects
            if (typeof this.currentState[key] === 'object') {
                serializedObject = this.serializeObject(key, this.currentState[key]);
                newPath += serializedObject;
                newCatalogPath += serializedObject;
            } else {
                newPath += '.' + key + '-' + this.currentState[key];

                //catalog url should never display state of "page 1"
                if (!((key === 'page') && (this.currentState[key].toString() === '1'))) {
                    newCatalogPath += '.' + key + '-' + this.currentState[key];
                }
            }
        }

        this.dynamicPath = newPath;
        this.catalogPath = newCatalogPath;

        if (that.usePopStateAssign) {
            window.history.pushState({
                currentState: this.currentState,
                serviceURL: this.serviceURL
            }, null, this.catalogURL);
        } else {
            window.history.pushState(null, null, this.catalogURL);
        }

        //to populate the browser change event when the user uses the browser btns
        window.onpopstate = function(e) {
            if (e.state) {
                HPEServices.publish(HPEConstants.router.BROWSER_POP_STATE, e.state.currentState);
                HPEServices.publish(HPEConstants.router.BROWSER_URL_CHANGE, e.state.serviceURL);
            }
        };

        //to populate the browser change event when the user click on any btn that change the url
        this.publishBrowserUrlChange();

    },

    /**
     * given a key and list of parameters, return a serialized selector string with those parameters
     * @param {string} key id of this key/value pair
     * @param {array} stateObject list of values
     * @return {string} formatted selector string
     */
    serializeObject: function(key, stateObject) {

        var urlString = '';
        var stateObjectLength = (stateObject) ? stateObject.length : 0;
        var count = 1;

        //iterate through passed stateObject and create formatted filter string
        if (key && stateObjectLength) {

            urlString = '.' + key + '-';

            stateObject.forEach(function(item) {
                if (item.values.length > 0) {
                    urlString += item.key + ':' + item.values.join(',');
                    if ((count !== stateObjectLength) && (stateObjectLength !== 1)) {
                        urlString += '|';
                    }
                    count++;
                }
            });
        }

        return urlString;
    }
});
